import { QUERY_KEYS } from 'api/query-keys';
import { documentsService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';

type SignDocumentParams = {
  documentId: string;
  dynamicProperties: Record<string, unknown>;
};

export const useSignDocument = () => {
  const mutationFn = async ({ documentId, dynamicProperties }: SignDocumentParams) =>
    await documentsService.signDocument(documentId, dynamicProperties);

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
